<template>
  <section>
    <nav :class="{ collapse: isCollapsed }" class="bd-links">
      <div
        v-for="n of nav"
        :key="n.root"
        v-if="!n.isHidden && isVisible(n.pages)"
        class="bd-toc-item"
        :class="{ active: n.isActive }"
        @click="isActive(n)"
      >
        <a class="bd-toc-link" href="#">
          {{ n.root }}
        </a>
        <ul class="nav bd-sidenav">
          <router-link
            exact
            tag="li"
            :to="p.url"
            v-for="p of n.pages"
            :key="p.name"
            v-if="!p.isHidden && isAllowed(p.url)"
          >
            <a href="#" v-if="p.url === '/calibrates/Submitted'">
              <i :class="p.icon"></i>
              <span>{{ p.name }}</span>
              <span class="badge-incoming" v-if="incomingCount > 0" title="# active requests">{{
                incomingCount
              }}</span>
              <span class="badge-unread" v-if="unreadCount > 0" title="# unread chats">{{
                unreadCount
              }}</span>
            </a>
            <a href="#" v-else>
              <i :class="p.icon"></i>
              <span>{{ p.name }}</span>
            </a>
          </router-link>
        </ul>
      </div>
      <div class="bd-toc-item active">
        <ul class="nav bd-sidenav">
          <li v-for="s of navSupport" :key="s.name">
            <a href="#" @click="performAction(s.action)">
              <i :class="s.icon"></i>
              <span>{{ s.name }}</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'nav-left',
  data() {
    return {
      searchText: '',
      isCollapsed: true,
      nav: [],
      navSupport: []
    }
  },
  mounted() {
    this.initMenu()
  },
  computed: {
    ...mapGetters('auth', ['profile', 'isAllowed']),
    ...mapGetters('chat', ['unreadCount']),
    ...mapGetters('calibrates', ['calibrateCounts']),
    isHost() {
      let _is = false
      if (
        this.profile.roles[0] === 1 ||
        this.profile.roles[0] === 2 ||
        this.profile.roles[0] === 6 ||
        this.profile.roles[0] === 10
      ) {
        _is = true
      }
      return _is
    },
    isShop() {
      let _is = false
      if (this.profile.roles[0] === 4 || this.profile.roles[0] === 5) {
        _is = true
      }
      return _is
    },
    isCenter() {
      let _is = false
      if (
        this.profile.roles[0] === 8 ||
        this.profile.roles[0] === 9 ||
        this.profile.roles[0] === 3 ||
        this.profile.roles[0] === 7
      ) {
        _is = true
      }
      return _is
    },
    isDispatch() {
      let _is = false
      if (this.profile.roles[0] === 12 || this.profile.roles[0] === 13) {
        _is = true
      }
      return _is
    },
    incomingCount() {
      let _count = 0
      console.log('Incoming Counts', this.calibrateCounts)
      if (this.calibrateCounts !== undefined && this.calibrateCounts !== null) {
        _count = this.calibrateCounts.inProcess !== null ? this.calibrateCounts.inProcess : 0
      }
      return _count
    }
  },
  methods: {
    ...mapActions('chat', ['quitChat']),
    ...mapActions('auth', ['clearToken']),
    initMenu() {
      this.nav = []
      if (this.isHost) {
        this.nav = [
          {
            root: '',
            isActive: true,
            pages: [
              { url: '/', name: 'Home', icon: '' },
              { url: '/brands', name: 'Brands', icon: 'fas fa-tags' },
              {
                url: '/locations',
                name: 'Locations',
                icon: 'fas fa-map-marker-alt'
              },
              { url: '/users', name: 'Users', icon: 'fas fa-users' },
              { url: '/storage', name: 'Storage', icon: 'fas fa-database' },
              { url: '/contacts', name: 'Contacts', icon: 'fas fa-phone-alt' },
              {
                url: '/insurance',
                name: 'Insurance',
                icon: 'fas fa-shield-alt'
              },
              { url: '/fleet', name: 'Fleet', icon: 'fas fa-truck' },
              {
                url: '/calibrates',
                name: 'Calibrate ROs',
                icon: 'fas fa-tachometer-alt'
              },
              {
                url: '/dispatch',
                name: 'Dispatch',
                icon: 'fas fa-shipping-fast'
              },
              {
                url: '/techschedule',
                name: 'Tech Schedule',
                icon: 'far fa-calendar-alt'
              },
              {
                url: '/configuration',
                name: 'Configuration',
                icon: 'fas fa-cogs'
              },
              {
                url: '/chatadmin',
                name: 'Chat Admin',
                icon: 'fas fa-cogs'
              }
            ]
          }
        ]
      } else if (this.isCenter) {
        this.nav = [
          {
            root: '',
            isActive: true,
            pages: [
              { url: '/', name: 'Home', icon: '' },
              {
                url: '/calibrates/Submitted',
                name: 'Incoming ROs',
                icon: 'fas fa-sign-in-alt'
              },
              {
                url: '/calibrates',
                name: 'Calibrate ROs',
                icon: 'fas fa-tachometer-alt'
              },
              {
                url: '/schedule',
                name: 'View Schedule',
                icon: 'far fa-calendar-alt'
              },
              { url: '/fleet', name: 'Fleet', icon: 'fas fa-truck' },
              {
                url: '/insurance',
                name: 'Insurance',
                icon: 'fas fa-shield-alt'
              },
              {
                url: '/dashboard',
                name: 'Dashboard',
                icon: 'fas fa-chart-line'
              },
              {
                url: '/locations',
                name: 'Locations',
                icon: 'fas fa-map-marker-alt'
              },
              { url: '/users', name: 'Users', icon: 'fas fa-users' }
              // { url: '/storage', name: 'Storage', icon: 'fas fa-database' },
              // {
              //   url: '/chatadmin',
              //   name: 'Chat Admin',
              //   icon: 'fas fa-cogs'
              // }
            ]
          }
        ]
      } else if (this.isDispatch) {
        this.nav = [
          {
            root: '',
            isActive: true,
            pages: [
              { url: '/', name: 'Home', icon: '' },
              {
                url: '/dispatch',
                name: 'Dispatch',
                icon: 'fas fa-shipping-fast'
              },
              {
                url: '/techschedule',
                name: 'Tech Schedule',
                icon: 'far fa-calendar-alt'
              },
              {
                url: '/locations',
                name: 'Locations',
                icon: 'fas fa-map-marker-alt'
              }
            ]
          }
        ]
      } else {
        this.nav = [
          {
            root: '',
            isActive: true,
            pages: [
              { url: '/', name: 'Home', icon: '' },
              {
                url: '/locations',
                name: 'Location',
                icon: 'fas fa-map-marker-alt'
              },
              {
                url: '/schedule',
                name: 'View Schedule',
                icon: 'far fa-calendar-alt'
              },
              {
                url: '/calibrates/Pending',
                name: 'Pending Requests',
                icon: 'fas fa-sign-in-alt'
              },
              {
                url: '/calibrates/Submitted',
                name: 'In Process Requests',
                icon: 'fas fa-sign-in-alt'
              },
              {
                url: '/calibrates',
                name: 'Calibrate Requests',
                icon: 'fas fa-tachometer-alt'
              },
              { url: '/fleet', name: 'Fleet', icon: 'fas fa-truck' },
              {
                url: '/insurance',
                name: 'Insurance',
                icon: 'fas fa-shield-alt'
              }
            ]
          }
        ]
      }
      this.navSupport = [
        { name: 'About', icon: '', action: 'about' },
        { name: 'Training Videos', icon: '', action: 'videos' },
        { name: 'Privacy Policy', icon: '', action: 'privacy' },
        { name: 'Logout', icon: '', action: 'logout' }
      ]
    },
    isActive(nav) {
      return true
    },
    isVisible(pages) {
      return pages.some(p => this.isAllowed(p.url))
    },
    search() {
      this.isCollapsed = false
      for (let n of this.nav) {
        n.isHidden = false
        let count = 0
        for (let p of n.pages) {
          p.isHidden = !p.name.toLowerCase().includes(this.searchText.toLowerCase())
          if (!p.isHidden) {
            count++
          }
        }
        n.isHidden = !count
      }
      this.$forceUpdate()
    },
    performAction(action) {
      if (action === 'about') {
        this.$router.push('/about')
      } else if (action === 'logout') {
        this.quitChat()
        this.clearToken()
        window.location.assign('/')
      } else if (action === 'privacy') {
        window.open('https://www.calcopilot.com/pages/privacy-policy', '_blank')
      } else if (action === 'videos') {
        window.open('https://www.calcopilot.com/cal-copilot-training-videos', '_blank')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.badge-incoming {
  position: relative;
  top: -5px;
  display: inline-flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  color: white;
  background: darkgreen;
  position: relative;
  box-sizing: border-box;
  text-align: center;
  vertical-align: middle;
  font-weight: normal;
  font-size: 12px;
  border-radius: 18px;
  padding: 0 4px;
  height: 18px;
  min-width: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/nav-left.vue